<div class="card-title">{{sortBy == 'asc' ? 'Bottom': 'Top'}} {{size}} {{selectedCohort.name}} - {{accessName}}</div>
<p *ngIf="sortBy == 'desc'">Highlights top actions and scores to pinpoint strengths and areas for growth</p>
<p *ngIf="sortBy == 'asc'">Identifies underperformers to pinpoint areas needing improvement.</p>
<div *ngIf="!isLoading">
    <app-score-table [tableColumns]="columns" [tableData]="response" [showDeviation]="showComparisonFlag"></app-score-table>
</div>
<div *ngIf="isLoading">
    <app-ltms-loader></app-ltms-loader>
</div>
